import React from 'react'
import { useAuth } from '@/shared/contexts'

const Forbidden: React.FC<{ title?: string; message?: string }> = ({ title, message }) => (
  <div className="flex-1 flex items-center justify-center p-12">
    <div className="text-center">
      <h2 className="text-xl font-semibold text-gray-900 mb-2">
        {title || 'Доступ запрещён'}
      </h2>
      <p className="text-gray-500">
        {message || 'У вашей роли нет прав на этот раздел. Обратитесь к администратору.'}
      </p>
    </div>
  </div>
)

export const RequirePermission: React.FC<{
  section: string
  action: string
  children: React.ReactNode
}> = ({ section, action, children }) => {
  const { hasPermission, isSuperadmin, permissions } = useAuth()
  if (!hasPermission(section, action)) {
    if (!isSuperadmin && permissions.length === 0) {
      return <Forbidden title="Роль не назначена" message="Обратитесь к администратору." />
    }
    return <Forbidden />
  }
  return <>{children}</>
}

export const RequireSuperadmin: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isSuperadmin } = useAuth()
  if (!isSuperadmin) return <Forbidden message="Раздел доступен только администратору." />
  return <>{children}</>
}
